<template>
  <div>
    <PanelGroup :key="group.id" v-for="group in groups" :heading="group.label">
      <PanelGroupCheckbox
        :key="item.id"
        v-for="item in group.items"
        :active="item.active"
        :disabled="item.active && isLastItemInGroup(group.id)"
        @change="active => $emit('change', group.id, item.id, active)"
      >
        {{ item.label }}
      </PanelGroupCheckbox>
    </PanelGroup>
  </div>
</template>

<script>
import PanelGroup from "../PanelGroup/PanelGroup";
import PanelGroupCheckbox from "../PanelGroupCheckbox/PanelGroupCheckbox";

export default {
  name: "MapFilter",
  components: {
    PanelGroup,
    PanelGroupCheckbox
  },
  props: {
    groups: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isLastItemInGroup(groupId) {
      const activeItems = this.groups
        .filter(group => group.id === groupId)[0]
        .items.filter(item => item.active);

      return activeItems.length === 1;
    }
  }
};
</script>
